// extracted by mini-css-extract-plugin
export default {"schudle":"Footer_schudle__MSctY","logo":"Footer_logo__+JiYo","button":"Footer_button__2oD+V"};